module.exports = __webpack_public_path__ + "static/gif-5468c614d0745e9770ee34dcf4961062.gif";